import {
    createBrowserRouter,
    RouteObject,
} from "react-router-dom";

import Root from './pages/Root';
import ErrorPage from './pages/Error';
import Login from './pages/Login';
import ForgotPassword from './pages/ForgotPassword';

import RegisterLayout from './pages/Register/RegisterLayout';
import RegisterBody from './pages/Register/RegisterBody';
import RegisterInfo from './pages/Register/RegisterInfo';
import { Profile, ProfilePassword, ProfileSettingArtist, ProfileSettingGallery, ProfileSettingStudio, ProfileSettingSlug, ProfileAbout } from './pages/Profile';

import Home from './pages/Home';
import Auth from "Auth";

// Create browser router
const routes: RouteObject[] = [
    {
        path: '/',
        element: <Auth><Root /></Auth>,
        errorElement: <ErrorPage />,
        children: [
            {
                path: "/",
                element: <Home />,
            },
            {
                path: "profile",
                element: <Profile />
            },
            {
                path: "profile/setting-gallery",
                element: <ProfileSettingGallery />
            },
            {
                path: "profile/setting-artist",
                element: <ProfileSettingArtist />
            },
            {
                path: "profile/reset-password",
                element: <ProfilePassword />
            },
            {
                path: "profile/setting-studio",
                element: <ProfileSettingStudio />
            },
            {
                path: "profile/about",
                element: <ProfileAbout />
            },
            {
                path: "profile/slug",
                element: <ProfileSettingSlug />
            }
        ]
    },
    {
        path: '/login',
        element: <Login />,
    },
    {
        path: '/forgotPassword',
        element: <ForgotPassword />,
    },
    {
        path: '/register',
        element: <RegisterLayout />,
        children: [
            {
                path: '/register',
                element: <RegisterBody userType='artist' />,
            },
            {
                path: '/register/gallery',
                element: <RegisterBody userType='gallery' />,
            },
            {
                path: '/register/info',
                element: <RegisterInfo />,
            },
        ]
    },
]

const router = createBrowserRouter(routes)

export default router